import type { PortalDashboardPageDefinition } from '@dlap-ui/shared-forms/shell/portal-shell/portal-shell';

export const HIGH_COURT_DASHBOARD_PAGES: readonly PortalDashboardPageDefinition[] = [
  {
    path: 'summary',
    label: 'Overview',
    icon: 'home',
    permission: 'overview',
    loadComponent: () => import('../overview/overview').then((m) => m.Overview),
  },
  {
    path: 'applications',
    label: 'Applications',
    icon: 'appstore',
    permission: 'applications',
    loadComponent: () =>
      import('../applications/applications').then((m) => m.Applications),
  },
  {
    path: 'applications/archived',
    label: 'Archived',
    icon: 'inbox',
    permission: 'applications/archived',
    loadComponent: () => import('../applications/archived/archived').then((m) => m.Archived),
  },
  {
    path: 'applications/drafts',
    label: 'Drafts',
    icon: 'file-text',
    permission: 'applications/drafts',
    loadComponent: () => import('../applications/drafts/drafts').then((m) => m.Drafts),
  },
  {
    path: 'fees',
    label: 'Fees',
    icon: 'dollar',
    permission: 'fees',
    loadComponent: () => import('../fees/fees').then((m) => m.Fees),
  },
  {
    path: 'wallet',
    label: 'Wallet',
    icon: 'wallet',
    permission: 'wallet',
    loadComponent: () => import('../wallet/wallet').then((m) => m.Wallet),
  },
  {
    path: 'users',
    label: 'Users',
    icon: 'team',
    permission: 'users',
    loadComponent: () => import('../users/users').then((m) => m.Users),
  },
  {
    path: 'profile',
    label: 'Profile',
    icon: 'idcard',
    permission: 'profile',
    showInMenu: false,
    loadComponent: () => import('@dlap-ui/shared-forms/profile/profile-page/profile-page').then((m) => m.ProfilePage),
  },
  {
    path: 'memberships/members',
    label: 'Members',
    icon: 'team',
    permission: 'memberships/members',
    loadComponent: () => import('../members/members').then((m) => m.Members),
  },
] as const;
